import {useMemo} from 'react';

import {MultiProcedureRunStudyDesignTabContentsQuery_procedureRun_ProcedureRunNode as ProcedureRunNode} from './__generated/MultiProcedureRunStudyDesignTabContentsQuery';
import {getActiveMethod, MethodIdAndName} from './activeMethodUtils';
import {getMethodExecutionStatuses, MethodExecutionStatus} from './getStudyDesignFromProcedureRun';

interface UseActiveMethodResult {
  activeMethod: MethodIdAndName | null;
  methodExecutionStatuses: Array<MethodExecutionStatus>;
  doesActiveMethodHaveDownstreamMethods: boolean;
}

export default function useActiveMethod(
  procedureRun: ProcedureRunNode,
  methods: Array<MethodIdAndName>
): UseActiveMethodResult {
  const methodExecutionStatuses = useMemo(() => getMethodExecutionStatuses(procedureRun), [procedureRun]);
  const activeMethod = useMemo(
    () => getActiveMethod(methods, methodExecutionStatuses),
    [methods, methodExecutionStatuses]
  );
  const doesActiveMethodHaveDownstreamMethods = useMemo(() => {
    if (activeMethod == null) {
      return false;
    }
    const activeUnitOpIndex = methods.findIndex((method) => method.id === activeMethod.id);
    return activeUnitOpIndex >= 0 && activeUnitOpIndex < methods.length - 1;
  }, [activeMethod, methods]);

  return {
    activeMethod,
    methodExecutionStatuses,
    doesActiveMethodHaveDownstreamMethods,
  };
}
